import iconWhatsApp from "../../assets/icons/whatsapp.svg";
import iconWppBusiness from "../../assets/icons/wppbusiness.svg";
import iconFacebook from "../../assets/icons/facebook.svg";
import { getNotificameApiUrl } from "../../config";

export const NOTIFICAME_API = getNotificameApiUrl();

const HUB_ICON = (fileName) => `/assets/icons/hub/${fileName}`;

export const CHANNEL_ICONS = {
	whatsapp: iconWhatsApp,
	whatsapp_business_account: HUB_ICON("whatsapp.png"),
	whatsappbusiness: iconWppBusiness,
	whatsappcloud: iconWppBusiness,
	facebook: iconFacebook,
	instagram: HUB_ICON("instagram.png"),
	telegram: HUB_ICON("telegram.png"),
	email: HUB_ICON("email.png"),
	sms: HUB_ICON("sms.png"),
	webchat: HUB_ICON("webchat.png"),
	mercadolivre: HUB_ICON("mercado-livre.png"),
	tiktok: HUB_ICON("tiktok.png"),
	ifood: HUB_ICON("ifood.png"),
	iFood: HUB_ICON("ifood.png"),
	youtube: HUB_ICON("youtube.png"),
	numero_virtual: HUB_ICON("numero-virtual.png"),
	olx: HUB_ICON("olx.png"),
	linkedin: HUB_ICON("linkedin.png"),
	magalu: HUB_ICON("magazine-luiza.png"),
	gbm: HUB_ICON("google-business.png"),
	google_ads: HUB_ICON("google-ads.png"),
	meta_ads: HUB_ICON("meta-ads.png"),
	shein: HUB_ICON("shein.png"),
	shopee: HUB_ICON("shopee.png"),
	facebook_instagram: HUB_ICON("facebook-instagram.svg"),
};

export function normalizeConnectionChannel(channel) {
	if (!channel) return "";
	const value = String(channel).trim();
	if (value === "mercado_livre") return "mercadolivre";
	if (value === "iFood") return "ifood";
	return value;
}

export const NATIVE_CHANNELS = [
	{
		id: "whatsapp",
		labelKey: "whatsappModal.form.whatsapp",
		descriptionKey: "connections.picker.channels.whatsapp.description",
		icon: CHANNEL_ICONS.whatsapp,
		recommended: true,
		buttonClass: "bg-green-600 hover:bg-green-700 text-white",
	},
];

export const SEAMLESS_CHANNELS = [
	{
		id: "facebook",
		oauthType: "facebook",
		labelKey: "whatsappModal.form.facebook",
		descriptionKey: "connections.picker.channels.hubFacebook.description",
		icon: CHANNEL_ICONS.facebook,
		buttonClass: "bg-blue-600 hover:bg-blue-700 text-white",
		recommended: true,
	},
	{
		id: "instagram",
		oauthType: "instagram",
		labelKey: "connections.marketplace.channelTypes.instagram",
		descriptionKey: "connections.picker.channels.hubInstagram.description",
		icon: CHANNEL_ICONS.instagram,
		buttonClass: "bg-pink-500 hover:bg-pink-600 text-white",
		recommended: true,
	},
	{
		id: "whatsapp",
		oauthType: "whatsapp",
		labelKey: "whatsappModal.form.whatsapp",
		descriptionKey: "connections.picker.channels.hubWhatsapp.description",
		icon: CHANNEL_ICONS.whatsapp_business_account,
		buttonClass: "bg-green-600 hover:bg-green-700 text-white",
		recommended: true,
	},
	{
		id: "youtube",
		oauthProvider: "youtube",
		labelKey: "connections.marketplace.channelTypes.youtube",
		descriptionKey: "connections.picker.channels.hubYoutube.description",
		icon: CHANNEL_ICONS.youtube,
		buttonClass: "bg-red-600 hover:bg-red-700 text-white",
	},
	{
		id: "gbm",
		oauthProvider: "googlebusiness",
		labelKey: "connections.marketplace.channelTypes.gbm",
		descriptionKey: "connections.picker.channels.hubGoogleBusiness.description",
		icon: CHANNEL_ICONS.gbm,
		buttonClass: "bg-blue-600 hover:bg-blue-700 text-white",
	},
	{
		id: "linkedin",
		oauthProvider: "linkedin",
		labelKey: "connections.marketplace.channelTypes.linkedin",
		descriptionKey: "connections.picker.channels.hubLinkedin.description",
		icon: CHANNEL_ICONS.linkedin,
		buttonClass: "bg-sky-700 hover:bg-sky-800 text-white",
	},
	{
		id: "olx",
		oauthProvider: "olx",
		labelKey: "connections.marketplace.channelTypes.olx",
		descriptionKey: "connections.picker.channels.hubOlx.description",
		icon: CHANNEL_ICONS.olx,
		buttonClass: "bg-purple-600 hover:bg-purple-700 text-white",
	},
	{
		id: "mercadolivre",
		oauthProvider: "mercadolivre",
		labelKey: "connections.marketplace.channelTypes.mercadolivre",
		descriptionKey: "connections.picker.channels.hubMercadoLivre.description",
		icon: CHANNEL_ICONS.mercadolivre,
		buttonClass: "bg-yellow-400 hover:bg-yellow-500 text-default-900",
	},
	{
		id: "tiktok",
		oauthProvider: "tiktok",
		labelKey: "connections.marketplace.channelTypes.tiktok",
		descriptionKey: "connections.picker.channels.hubTiktok.description",
		icon: CHANNEL_ICONS.tiktok,
		buttonClass: "bg-default-900 hover:bg-default-800 text-white dark:bg-default-100 dark:text-default-900",
	},
];

// Meta usa /v2/oauth/meta/start?type=...; demais provedores usam /v2/oauth/{provider}/start.
export function buildSeamlessStartUrl(channel, companyUuid, redirectOrigin) {
	const provider = channel?.oauthProvider || "meta";
	const params = new URLSearchParams({
		company_uuid: companyUuid,
		redirect_origin: redirectOrigin,
	});
	if (provider === "meta") {
		params.set("type", channel.oauthType);
	}
	return `${NOTIFICAME_API}/v2/oauth/${encodeURIComponent(provider)}/start?${params.toString()}`;
}

/** @deprecated use SEAMLESS_CHANNELS */
export const HUB_CHANNELS = SEAMLESS_CHANNELS;

export const HUB_CHANNEL_CARD = {
	id: "hub",
	labelKey: "connections.picker.channels.hubIntegration.label",
	descriptionKey: "connections.picker.channels.hubIntegration.description",
	icon: HUB_ICON("notificame.png"),
	buttonClass: "bg-violet-600 hover:bg-violet-700 text-white",
	recommended: true,
};

export function getChannelIcon(channelId, options = {}) {
	const normalized = normalizeConnectionChannel(channelId);

	if (options?.facebookLinkedInstagram && normalized === "facebook") {
		return CHANNEL_ICONS.facebook_instagram;
	}

	if (CHANNEL_ICONS[normalized]) {
		return CHANNEL_ICONS[normalized];
	}

	const seamless = SEAMLESS_CHANNELS.find(
		(c) => c.oauthType === normalized || c.id === normalized
	);
	if (seamless?.icon) {
		return seamless.icon;
	}

	return CHANNEL_ICONS.webchat;
}

export function getNativeChannelLabel(channelId) {
	const item = NATIVE_CHANNELS.find((c) => c.id === channelId);
	return item?.labelKey || channelId;
}

const CHANNEL_LABEL_KEYS = {
	whatsapp: "whatsappModal.form.whatsapp",
	whatsapp_business_account: "whatsappModal.form.whatsapp",
	whatsappbusiness: "whatsappModal.form.whatsappcloud",
	whatsappcloud: "whatsappModal.form.whatsappcloud",
	facebook: "whatsappModal.form.facebook",
	instagram: "connections.marketplace.channelTypes.instagram",
	telegram: "whatsappModal.form.telegram",
	email: "connections.picker.channels.email.label",
	webchat: "connections.marketplace.channelTypes.webchat",
	sms: "connections.marketplace.channelTypes.sms",
	mercadolivre: "connections.marketplace.channelTypes.mercadolivre",
	tiktok: "connections.marketplace.channelTypes.tiktok",
	ifood: "connections.marketplace.channelTypes.ifood",
	youtube: "connections.marketplace.channelTypes.youtube",
	numero_virtual: "connections.marketplace.channelTypes.numero_virtual",
	olx: "connections.marketplace.channelTypes.olx",
	linkedin: "connections.marketplace.channelTypes.linkedin",
	magalu: "connections.marketplace.channelTypes.magalu",
	gbm: "connections.marketplace.channelTypes.gbm",
	google_ads: "connections.marketplace.channelTypes.google_ads",
	meta_ads: "connections.marketplace.channelTypes.meta_ads",
	shein: "connections.marketplace.channelTypes.shein",
	shopee: "connections.marketplace.channelTypes.shopee",
};

export function getConnectionChannelLabelKey(channel) {
	if (!channel) return "";
	return CHANNEL_LABEL_KEYS[normalizeConnectionChannel(channel)] || channel;
}

export function formatConnectionChannelLabel(channel, translate = (key) => key) {
	const labelKey = getConnectionChannelLabelKey(channel);
	if (!labelKey) return "";
	return labelKey.includes(".") ? translate(labelKey) : labelKey;
}

export function formatHubChannelName(item) {
	if (!item?.name) return String(item?.id || "");
	return item.name.charAt(0).toUpperCase() + item.name.slice(1);
}

export function formatHubChannelOptionLabel(item, translate = (key) => key) {
	const typeLabel = formatConnectionChannelLabel(item?.channel, translate);
	const name = formatHubChannelName(item);
	if (!typeLabel) return name;
	if (!name) return typeLabel;
	return `${typeLabel} · ${name}`;
}

const CHANNEL_BADGE_CLASSES = {
	whatsapp: "bg-green-500/10 text-green-700 dark:text-green-300",
	whatsappcloud: "bg-green-500/10 text-green-700 dark:text-green-300",
	whatsapp_business_account: "bg-green-500/10 text-green-700 dark:text-green-300",
	whatsappbusiness: "bg-green-500/10 text-green-700 dark:text-green-300",
	facebook: "bg-blue-500/10 text-blue-700 dark:text-blue-300",
	instagram: "bg-pink-500/10 text-pink-700 dark:text-pink-300",
	telegram: "bg-sky-500/10 text-sky-700 dark:text-sky-300",
	email: "bg-amber-500/10 text-amber-800 dark:text-amber-200",
	webchat: "bg-violet-500/10 text-violet-700 dark:text-violet-300",
	sms: "bg-orange-500/10 text-orange-700 dark:text-orange-300",
	mercadolivre: "bg-yellow-500/10 text-yellow-800 dark:text-yellow-200",
	tiktok: "bg-default-100 text-default-800 dark:bg-default-800 dark:text-default-100",
	ifood: "bg-red-500/10 text-red-700 dark:text-red-300",
	youtube: "bg-red-500/10 text-red-700 dark:text-red-300",
	numero_virtual: "bg-indigo-500/10 text-indigo-700 dark:text-indigo-300",
	olx: "bg-purple-500/10 text-purple-700 dark:text-purple-300",
	linkedin: "bg-sky-500/10 text-sky-800 dark:text-sky-200",
	magalu: "bg-blue-500/10 text-blue-800 dark:text-blue-200",
	gbm: "bg-blue-500/10 text-blue-800 dark:text-blue-200",
	google_ads: "bg-amber-500/10 text-amber-800 dark:text-amber-200",
	meta_ads: "bg-blue-500/10 text-blue-700 dark:text-blue-300",
	shein: "bg-default-100 text-default-800 dark:bg-default-800 dark:text-default-100",
	shopee: "bg-orange-500/10 text-orange-700 dark:text-orange-300",
};

export function getChannelBadgeClass(channel) {
	const normalized = normalizeConnectionChannel(channel);
	return (
		CHANNEL_BADGE_CLASSES[normalized] ||
		"bg-default-100 text-default-700 dark:bg-default-800 dark:text-default-200"
	);
}

export function getConnectionIntegrationType(connection) {
	if (!connection) return "native";
	if (connection.integrationSource) return connection.integrationSource;
	if (!connection.hub) return "native";
	return "hub";
}

const INTEGRATION_BADGE_CLASSES = {
	native: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
	hub: "bg-violet-500/10 text-violet-600 dark:text-violet-400",
	seamless: "bg-sky-500/10 text-sky-700 dark:text-sky-300",
};

export function getIntegrationBadgeClass(integrationType) {
	return INTEGRATION_BADGE_CLASSES[integrationType] || INTEGRATION_BADGE_CLASSES.native;
}

const INTEGRATION_CARD_CLASSES = {
	native:
		"border-success/30 bg-success/5 dark:border-success/20 dark:bg-success/5",
	hub: "border-violet-400/35 bg-violet-500/8 dark:border-violet-400/25 dark:bg-violet-500/10",
	seamless: "border-sky-400/35 bg-sky-500/8 dark:border-sky-400/25 dark:bg-sky-500/10",
};

const INTEGRATION_CARD_FOOTER_CLASSES = {
	native: "border-success/20 dark:border-success/10",
	hub: "border-violet-400/20 dark:border-violet-400/15",
	seamless: "border-sky-400/20 dark:border-sky-400/15",
};

export function getIntegrationCardClass(integrationType) {
	return INTEGRATION_CARD_CLASSES[integrationType] || INTEGRATION_CARD_CLASSES.native;
}

export function getIntegrationCardFooterClass(integrationType) {
	return INTEGRATION_CARD_FOOTER_CLASSES[integrationType] || INTEGRATION_CARD_FOOTER_CLASSES.native;
}
